<template>
  <div
    :class="[$style.box]"
    @click="$router.push({
      name: 'Article',
      params: {
        articleId: data.articleId
      }
    })"
  >
    <template v-if="!data.isEmpty">
      <img
        :class="$style.cover"
        :src="data.cover"
        alt=""
      >
      {{ data.title }}
      {{ data.subtitle }}
    </template>
  </div>
</template>

<script>
export default {
  name: 'FeedItem',
  props: {
    data: { type: Object, default: () => { return { isEmpty: true } } }
  }

}
</script>

<style module>
.box{
  position: relative;
  display: flex;
  flex-direction: column;
  /* margin: 24px; */

  max-width: 390px;
  width: 33.33vw;
}

.cover {
  max-width:390px;
  max-height:390px;
  width: 33.33vw;
  height: 33.33vw;
  object-fit: cover;
}

</style>
